import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useDbQuery } from '../hooks/useDbQuery';
import { jsx as ___EmotionJSX } from "@emotion/core";

var SEO = function SEO(_ref) {
  var description = _ref.description,
      lang = _ref.lang,
      meta = _ref.meta,
      keywords = _ref.keywords,
      initialTitle = _ref.title;
  var db = useDbQuery();
  var title = initialTitle || db.config.title;
  var metaDescription = description || db.config.description;
  return ___EmotionJSX(Helmet, {
    title: title,
    titleTemplate: "%s | " + db.config.title,
    htmlAttributes: {
      lang: lang
    },
    meta: [{
      name: "description",
      content: metaDescription
    }, {
      property: "og:title",
      content: title
    }, {
      property: "og:description",
      content: metaDescription
    }, {
      property: "og:type",
      content: "website"
    }, {
      name: "twitter:card",
      content: "summary"
    }, {
      name: "twitter:title",
      content: title
    }, {
      name: "twitter:description",
      content: metaDescription
    }].concat(keywords.length > 0 ? {
      name: "keywords",
      content: keywords.join(", ")
    } : []).concat(meta)
  });
};

SEO.defaultProps = {
  lang: "en",
  meta: [],
  keywords: []
};
export default SEO;

if (typeof SEO !== 'undefined' && SEO && SEO === Object(SEO) && Object.isExtensible(SEO) && !SEO.hasOwnProperty('__filemeta')) {
  Object.defineProperty(SEO, '__filemeta', {
    configurable: true,
    value: {
      name: "SEO",
      filename: "node_modules/gatsby-theme-docz/src/base/Seo.js"
    }
  });
}